import React from 'react';

const Intro = ({
  onClick
}) => (
  <div>
    <div className="modal-content">
      <p className="test_text_question">
        You need to answer 8 out of 10 questions to get your CPD points for this webinar.
      </p>
      <div className="submit_center col s12">
        <input
          className="test_submit"
          type="submit"
          name=""
          value="START THE QUIZ"
          onClick={onClick}
        />
      </div>
    </div>
  </div>
)

export default Intro;



/** WEBPACK FOOTER **
 ** ./src/components/Quiz/Intro.jsx
 **/